// ── V146: 셈핏 버전 표시 ─────────────────────────────────────────────────────
// 배포할 때마다 public/service-worker.js 의 CACHE_NAME 끝(-v146)과 같이 올린다.
// 설정 맨 위·로그인 화면 아래에 보이고, '새 버전 확인'은 서버의 service-worker.js 와 비교한다.
export const APP_VERSION = 'V168';
export const APP_DATE = '2026-11-04';

/** service-worker.js 글에서 버전 번호 (… -v146' → 146) */
export function swVersionNumber(text) {
  const m = String(text || '').match(/CACHE_NAME\s*=\s*['"][^'"]*-v(\d+)['"]/);
  return m ? Number(m[1]) : null;
}

export const appVersionNumber = () => Number(APP_VERSION.replace(/\D/g, '')) || 0;
